export const tableHeaders = (isVisitNote = true) => ({
  headersPMH: [
    {
      text: "PMH",
      value: "name",
      width: "80%",
      class: "table-header",
    },
    {
      text: "Year",
      value: "year",
      width: "10%",
      align: "center",
      class: "table-header",
    },
  ],
  headersPSH: [
    { text: "PSH", value: "name", width: "80%", class: "table-header" },
    {
      text: "Year",
      value: "year",
      width: "10%",
      align: "center",
      class: "table-header",
    },
  ],
  headersIssues: [
    {
      text: "Complaints",
      value: "firstValue",
      width: "20%",
      class: "table-header",
    },
    {
      text: isVisitNote ? "Physical Examination" : "Physical exam",
      value: "secondValue",
      width: "80%",
      class: "table-header",
    },
    { text: "", value: "action", width: "10%", align: "center" },
  ],
  headersAssesments: [
    {
      text: "Assessment",
      value: "firstValue",
      width: "20%",
      class: "table-header",
    },
    {
      text: isVisitNote ? "Note (Plan/Instructions)" : "Problem Notes",
      value: "secondValue",
      width: "80%",
      class: "table-header",
    },
    { text: "", value: "action", width: "10%", align: "center" },
  ],
});
